/* eslint-disable @wix/da/create-action-payload-creator */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useMemo, useReducer } from 'react';
import { FolderType } from './redux/types';
import { createAction } from 'redux-actions';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
const setSelectedGroup = createAction('selectGroup');
const resetSelectedGroup = createAction('resetGroup');
const setSelectedSubmissionType = createAction('selectType');
const setFilter = createAction('setFilter');
const initialState = {
    selectedSubmissionType: FolderType.Gallery,
    filterValue: ''
};
function reducer(prevState, action) {
    switch(action.type){
        case 'selectGroup':
            return _object_spread_props(_object_spread({}, prevState), {
                selectedGroup: action.payload,
                filterValue: ''
            });
        case 'resetGroup':
            return initialState;
        case 'selectType':
            return _object_spread_props(_object_spread({}, prevState), {
                selectedSubmissionType: action.payload,
                filterValue: ''
            });
        case 'setFilter':
            return _object_spread_props(_object_spread({}, prevState), {
                filterValue: action.payload
            });
        default:
            return prevState;
    }
}
export function useAddToGroupFlow() {
    const [{ selectedGroup, selectedSubmissionType, filterValue }, dispatch] = useReducer(reducer, initialState);
    return useMemo(()=>({
            selectedGroup,
            selectedSubmissionType,
            filterValue,
            selectGroup: (group)=>yieldToMain(()=>dispatch(setSelectedGroup(group))),
            resetSelectedGroup: ()=>yieldToMain(()=>dispatch(resetSelectedGroup())),
            selectSubmissionType: (type)=>yieldToMain(()=>dispatch(setSelectedSubmissionType(type))),
            onFilterInputChange: (e)=>yieldToMain(()=>dispatch(setFilter(e.target.value)))
        }), [
        filterValue,
        selectedGroup,
        selectedSubmissionType
    ]);
}
